import lottie from 'lottie-web'
import { elementInView, scrollFunction } from '../utils/_scroll-handler'

export default function Lotti () {
  const CONTAINERS = document.querySelectorAll('.mtt-cover-widget__animation-inner, .mtt-fourofour__animation-inner')

  if (CONTAINERS.length) {
    for (let i = 0; i < CONTAINERS.length; i++) {
      const CONTAINER = CONTAINERS[i]
      const PATH = CONTAINER.getAttribute('data-path')
      const IMG = CONTAINER.querySelector('img')
      let playing = false

      const anim = lottie.loadAnimation({
        container: CONTAINER, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: PATH + 'resources/animations/coveranimation.json', // the path to the animation json
        rendererSettings: {
          progressiveLoad: true
        }
      })

      // Play animation when data is ready, and remove the placeholder image
      anim.addEventListener('data_ready', () => {
        IMG && IMG.parentNode.removeChild(IMG)
        if (elementInView(CONTAINER)) {
          anim.play()
          playing = true
        }
      })

      // Stop animation when no longer in view
      scrollFunction(() => {
        if (elementInView(CONTAINER) && !playing) {
          anim.play()
          playing = true
        } else if (!elementInView(CONTAINER) && playing) {
          anim.stop()
          playing = false
        }
      })
    }
  }
}